import { gql } from "@apollo/client";

export const JOIN_INITIATIVE = gql`
  mutation JoinInitiative($data: JoinInitiativeInputData!) {
    joinInitiative(data: $data) {
      id
      initiativeId
      organizationId
      status
    }
  }
`;
